


























































































import Vue from 'vue';
import { EInputIdentifier } from '@/common/enums/input-identifier.enum';
import { EInputType } from '@/common/enums/frontpage.enum';
import { INewsletterForm } from '@/common/interfaces/frontpage.interface';
import FrontpageInput from '../formcomponents/FrontpageInput.vue';
import CustomSelect from '../../../layout/inputs/CustomSelect.vue';
import Checkbox from '../../../myprofile/inputs/Checkbox.vue';
import FrontpageButton from '../formcomponents/FrontpageButton.vue';
import ArrowIcon from '../../../icons/ArrowIcon.vue';
import LoadingSpinner from '../../../common/loading/LoadingSpinner.vue';

export default Vue.extend({
  name: `NewsletterForm`,
  components: {
    ArrowIcon,
    Checkbox,
    CustomSelect,
    FrontpageButton,
    FrontpageInput,
    LoadingSpinner,
  },
  data(): INewsletterForm {
    return {
      EInputIdentifier,
      EInputType,
      formData: {
        email: ``,
        firstName: ``,
        gender: 0,
        lastName: ``,
      },
      genderOptions: [],
      mustAcceptTerms: false,
      startedTyping: false,
      termsAccepted: false,
    };
  },
  props: {
    isChristmas: {
      default: false,
      type: Boolean,
    },
    openExtended: {
      default: false,
      type: Boolean,
    },
    registrationInProgress: {
      default: false,
      type: Boolean,
    },
  },
  async mounted(): Promise<void> {
    this.startedTyping = this.openExtended;
    const salutations = await this.$zApiService.getSalutations();
    this.genderOptions = salutations.map(salutation => {
      return {
        code: salutation.id,
        label: salutation.salutation,
      };
    });
    this.formData.gender = this.genderOptions[0].code;
  },
  methods: {
    submitForm(): void {
      if(!this.termsAccepted) {
        this.mustAcceptTerms = true;
        return;
      }
      this.$emit(`subscribe:newsletter`, this.formData);
    },
    updateEmail(value: string): void {
      this.startedTyping = value.length > 0;
      this.formData.email = value;
    },
    updateFirstName(value: string): void {
      this.formData.firstName = value;
    },
    updateGender(value: number): void {
      this.formData.gender = value;
    },
    updateLastName(value: string): void {
      this.formData.lastName = value;
    },
    updateTermsAccepted(): void {
      this.termsAccepted = !this.termsAccepted;
    },
  },
});
